import { render } from "./ScheduleFormStepDemand.vue?vue&type=template&id=5604466b"
import script from "./ScheduleFormStepDemand.vue?vue&type=script&lang=ts"
export * from "./ScheduleFormStepDemand.vue?vue&type=script&lang=ts"
script.render = render

export default script